import React from 'react';
import { FaCheckCircle, FaCheck, FaStar, FaBuilding, FaLandmark } from 'react-icons/fa';
import { motion } from 'framer-motion';

const VerificationBadge = ({ badgeType, size = 'md', showTooltip = true, className = '' }) => {
  if (!badgeType) return null;

  const badgeConfig = {
    verified: {
      icon: FaCheckCircle,
      color: '#1DA1F2', // Twitter blue
      bgColor: 'bg-blue-500',
      label: 'Verified',
      description: 'This account is verified as notable'
    },
    official: {
      icon: FaCheckCircle,
      color: '#FFD700', // Gold
      bgColor: 'bg-yellow-500',
      label: 'Official',
      description: 'Official organization account'
    },
    creator: {
      icon: FaStar,
      color: '#A855F7', // Purple
      bgColor: 'bg-purple-500',
      label: 'Creator',
      description: 'Verified content creator'
    },
    business: {
      icon: FaBuilding,
      color: '#6B7280', // Gray
      bgColor: 'bg-gray-500',
      label: 'Business',
      description: 'Verified business account'
    },
    government: {
      icon: FaLandmark,
      color: '#6B7280', // Gray
      bgColor: 'bg-gray-600',
      label: 'Government',
      description: 'Government or official entity'
    }
  };

  const config = badgeConfig[badgeType] || badgeConfig.verified;
  const Icon = config.icon;

  const sizeClasses = {
    xs: 'w-3 h-3 text-[10px]',
    sm: 'w-4 h-4 text-xs',
    md: 'w-5 h-5 text-sm',
    lg: 'w-6 h-6 text-base',
    xl: 'w-8 h-8 text-lg'
  };

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className={`relative inline-flex items-center justify-center group ${className}`}
      title={showTooltip ? `${config.label}: ${config.description}` : ''}
    >
      <Icon 
        className={`${sizeClasses[size]}`}
        style={{ color: config.color }}
      />
      
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
          <div className="flex items-center space-x-2">
            <Icon style={{ color: config.color }} />
            <span className="font-medium">{config.label}</span>
          </div>
          <p className="text-gray-400 mt-1">{config.description}</p>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
            <div className="border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default VerificationBadge;
